module.exports = __webpack_public_path__ + "static/media/McNatt_Mark.dfb7f31a.png";